<div
  class="wrap"
  [class.pr-large-t]="enableTopPadding"
  [class.pr-large-b]="enableBottomPadding"
  data-testid="booking-plain-header"
>
  <h1 class="font-heading-3 ms-clear {{ headingClass }} font-headline-small">{{ title }}</h1>
  <p class="font-body-1 nordic-blue-900-text text-icon-primary font-body-medium" *ngIf="subtitle">{{ subtitle }}</p>
  <p class="font-body-1 mr-small-t nordic-blue-900-text text-icon-primary font-body-medium" *ngIf="extraText">
    {{ extraText }}
  </p>
  <ng-content></ng-content>
</div>
